/* eslint-disable import/no-anonymous-default-export */
export default theme => ({
  page__wrapper: {
    backgroundColor: '#FAFAFA',
    margin: '0 16px',
    padding: 5,
  },
  page__header: {
    marginBottom: 24
  },
  List: {
    marginTop: '20px',
    minWidth: '240px',   
    maxHeight: '400px',
    overflowY: 'auto',
    padding: '16px 16px 0 16px',
    //background: '#FFFFFF',
    //boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
    borderRadius: '5px',
  },
  List__root: {
    maxWidth: '740px',
    maxHeight: '420px',
    overflowY: 'auto',
    backgroundColor: '#FAFAFA',
    marginTop: '20px',
  },
  List__root_item: {
    display: 'flex',
    alignItems: 'center',
    background: '#FAFAFA',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
    borderRadius: '5px',
    marginBottom: '15px',
    minHeight: '85px',
    maxHeight: '85px',
    cursor: 'pointer',
  },
  List__root_item2: {
    paddingBottom: '30px',
    borderBottom: '1px solid #CBCBCB',
  },
  List__root_item3: {
    // borderBottom: '1px solid #CBCBCB',
    // display: 'flex',
    // alignItems: 'center',
    // padding: '8px 16px'
    display: 'flex',
    alignItems: 'center',
    background: '#FAFAFA',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
    borderRadius: '5px',
    marginBottom: '15px',
    minHeight: '85px',
    maxHeight: '85px',
    cursor: 'pointer',
  },
  ellipse: {
    marginTop: '-4px',
    marginLeft: '-12px',
    marginRight: '10px',
  },
  List__inline: {
    display: 'inline',
  },
  page__form: {
    padding: 8,
  },
  page__title: {
    marginTop: 8,
  },
  root: {
    maxWidth: 650,
    height: 850,
    flexGrow: 1,
    background: '#FAFAFA',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent'
  },
  img: {
    height: 255,
    maxWidth: 400,
    overflow: 'hidden',
    display: 'block',
    width: '100%',
  },
  body__fields_radio: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    maxHeight: '320px',
    maxWidth: '400px',
    margin: '0 auto',
    overflowY: 'auto',
    background: '#FAFAFA',
    padding: '5px 5px 0 10px',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
    borderRadius: '5px',
    border: '1px solid #0000000a',
  },
  body__fields_number: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '280px',
    maxWidth: '400px',
    margin: '0 auto',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
    borderRadius: '5px',
    border: '1px solid #0000000a'
  },
  body__fields_date: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '280px',
    maxWidth: '400px',
    margin: '0 auto',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
    borderRadius: '5px',
    border: '1px solid #0000000a',
  },
  body__fields_text: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '280px',
    maxWidth: '400px',
    margin: '0 auto',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
    borderRadius: '5px',
    border: '1px solid #0000000a',
  },
  body__fields: {
    display: 'flex',
    alignItems: 'center'
  },
  Buttons: {
    display: 'flex',
    alignItens: 'center',
    gap: '20px',
    marginTop: '20px'
  },
  Box_buttons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
})